import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-right",
  templateUrl: "./med-icon-arrow-right.component.html",
})
export class MedIconArrowRightComponent extends SvgMixinComponent {}
